import styled from "styled-components";
import { styledByTheme } from "../../../../../../themes/architecture/styled-by-theme";
import { DepositSideMenuItemBox } from "../deposit/deposit-side-menu-item.box";

const SignupSideMenuItemCasino888Box = styled(DepositSideMenuItemBox)`
    font-size: 1.6rem;
    color: ${({theme}) => theme.colors.moneyColor };
`;

export const SignupSideMenuItemBox = styledByTheme(DepositSideMenuItemBox)
    .forCasino888(SignupSideMenuItemCasino888Box)
    .forDelawarePark(SignupSideMenuItemCasino888Box)
    .forBallysDover(SignupSideMenuItemCasino888Box)
    .forHarrington(SignupSideMenuItemCasino888Box)
    .apply();
